<template>
  <div class="tele2-banner">
    <div class="container">
      <div class="tele2-banner__inner">
        <div class="tele2-banner__left tele2-banner__item">
          <div class="tele2-banner__text">
            <h1 class="tele2-banner__title">
              {{ $t('banner.title')}}
            </h1>
            <div class="tele2-banner__description">
              {{ $t('banner.subtitle')}}
            </div>
          </div>
        </div>
        <div class="tele2-banner__right tele2-banner__item">
          <img
            class="tele2-banner__img"
            src="@/assets/img/tele2visual.png"
            alt="banner"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.tele2-banner{
    background: $primary-black;
    &__inner{
        display: flex;
        height: 240px;
        padding: 0 16px;
    }
    &__item{
        flex: 1;
        display: flex;
    }
    &__item:last-child{
      align-items: flex-end;
    }
    &__title{
        font-style: normal;
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;
        color: $primary-white;
        margin-bottom: 16px;
        font-weight: 700;
        width: 80%;
    }
    &__description{
        font-weight: 600;
        font-size: 17px;
        line-height: 24px;
        color: $primary-white;
        font-family: 'Open Sans';
        font-style: normal;
        letter-spacing: -0.03em;
    }
    &__text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }
    &__img{
      display: block;
      max-width: 468px;
      max-height: 333px;
    }
}
@media (min-width: 320px) and (max-width: 641px) {
.tele2-banner{
    &__inner{
        flex-direction: column;
        height: 200px;
        padding: 0;
    }
    &__right{
      display: none;
    }
    &__title{
        font-size: 24px;
        line-height: 34px;
        width: 100%;
        margin: 0 0 8px 0;
    }
    &__description{
        font-size: 16px;
        line-height: 19px;
        width: 100%;
    }
    &__img{
        display: none;
    }

}
}
@media (min-width: 642px) and (max-width: 768px) {
  .tele2-banner{
    &__title{
        font-size: 30px;
        line-height: 38px;
        width: 100%;
    }
    &__description{
      font-size: 18px;
      width: 100%;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
    &__inner{
      padding: 0;
    }
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
.tele2-banner{
    &__title{
        font-size: 32px;
        line-height: 42px;
        width: 80%;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
    &__description{
      width: 60%;
    }
    &__inner{
      // padding: 0;
    }
}
}
</style>
